import React from 'react';
import { getEventHosts } from '../utils/eventUtils';

/**
 * Shared registration/event-page links for an event. Co-hosted events receive
 * one link per host; single-host events keep the compact generic label.
 */
const RegistrationLinks = ({
    event,
    variant = 'event-page',
    buttonClassName = '',
    buttonStyle,
    singleLinkClassName = '',
    multipleLinkClassName = '',
    singleContainerClassName = '',
    multipleContainerClassName = 'flex flex-col gap-2',
    showLinks = true,
    renderAfterLinks,
}) => {
    const hosts = showLinks ? getEventHosts(event).filter((host) => host.eventURL) : [];
    const multiple = hosts.length > 1;
    const containerClassName = multiple ? multipleContainerClassName : singleContainerClassName;
    const linkClassName = multiple ? multipleLinkClassName : singleLinkClassName;

    const getLabel = (host) => {
        if (host.eventURL === '/private-events') return 'About private events';
        if (!multiple) return variant === 'register' ? 'Register' : 'Go to event page';
        return variant === 'register'
            ? `Register via ${host.organization}`
            : `Go to event page (${host.organization})`;
    };

    return (
        <div className={containerClassName}>
            {hosts.map((host, index) => (
                <a
                    key={`${host.organization || 'host'}-${host.eventURL}-${index}`}
                    href={host.eventURL}
                    className={`${buttonClassName} ${linkClassName}`.trim()}
                    style={buttonStyle}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Go to event page for ${event?.title}${multiple ? ` via ${host.organization}` : ''}`}
                >
                    {getLabel(host)}
                </a>
            ))}
            {renderAfterLinks?.(multiple)}
        </div>
    );
};

export default RegistrationLinks;
